"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MidiCommand = void 0;
exports.MidiCommand = {
    NoteOn: 0b1001 << 4,
    NoteOff: 0b1000 << 4,
    PolyKeyPressure: 0b1010 << 4,
    ControlChange: 0b1011 << 4,
    ProgramChange: 0b1100 << 4,
    ChannelPressure: 0b1101 << 4,
    PitchBend: 0b1110 << 4,
    Sysex: 0b1111 << 4,
    Clock: {
        Start: 0xfa,
        Continue: 0xfb,
        Stop: 0xfc,
        Pulse: 0xf8,
    },
};
